import auroraColorPalette from '../colors';

const dialogTitle = {
  root: {
    position: 'relative',
    marginBottom: 32,
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 60,
      height: 4,
      background: auroraColorPalette.primary.main,
      bottom: 0,
      left: 26,
    },
    '& h2': {
      color: auroraColorPalette.primary.dark,
    },
  },
};

export default dialogTitle;
